module.exports = __webpack_public_path__ + "static/media/awesome-video.7a14379c.svg";